const faqs = [
  {
    q: "What is a Pandabuy spreadsheet?",
    a: "A Pandabuy spreadsheet is a curated, organized collection of product links from the Pandabuy platform, typically compiled by experienced shoppers. It includes item names, prices, quality ratings, seller reliability notes, and shipping estimates — all structured in a searchable format that saves you hours of hunting through random links.",
  },
  {
    q: "Is Pandabuy spreadsheet safe to use?",
    a: "Yes, our Pandabuy spreadsheet is completely safe. We only include links from verified sellers with positive community feedback. Each entry includes seller reliability notes so you can make informed decisions. However, always exercise standard online shopping precautions when making purchases.",
  },
  {
    q: "How often is the Pandabuy spreadsheet updated?",
    a: "Our Pandabuy spreadsheet is updated daily with new finds, price adjustments, and seller status changes. Dead links are removed within 24 hours, and new trending products from the community are added every week to keep the sheet fresh and reliable.",
  },
  {
    q: "What categories are included in the Pandabuy spreadsheet?",
    a: "Our Pandabuy spreadsheet covers 14 categories: Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and Other miscellaneous finds. Each category is independently curated for quality and value.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Header */}
          <div className="lg:w-1/2 flex flex-col justify-center">
            <span className="inline-block w-fit text-[11px] font-label font-semibold text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full uppercase tracking-wider mb-6">
              FAQ
            </span>
            <h2 className="font-heading text-[38px] md:text-[48px] leading-[1.12] text-foreground-950 font-bold tracking-[-0.02em]">
              Everything You Need
              <br />
              to Know About Our
              <br />
              Pandabuy Spreadsheet
            </h2>
            <p className="mt-5 text-[15px] text-foreground-500 leading-relaxed max-w-[440px]">
              Got questions about how our Pandabuy spreadsheet works? We've compiled answers to the
              most common questions from our community of spreadsheet users.
            </p>
          </div>

          {/* Right - FAQ Card */}
          <div className="lg:w-1/2">
            <div className="bg-primary-800 rounded-[28px] p-8 md:p-10 text-background-50">
              <div className="flex items-center justify-between mb-8">
                <span className="text-[12px] font-label font-semibold text-background-50/50 uppercase tracking-wider">
                  Top Questions
                </span>
                <div className="flex gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/30"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/30"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50/30"></span>
                </div>
              </div>

              <div className="space-y-7">
                {faqs.map((faq, i) => (
                  <div key={i}>
                    <h4 className="text-[15px] font-label font-bold text-background-50 mb-2">
                      <a href={`#faq-item-${i}`} id={`faq-item-${i}`}>
                        {faq.q}
                      </a>
                    </h4>
                    <p className="text-[13px] text-background-50/75 leading-relaxed font-body">
                      {faq.a}
                    </p>
                  </div>
                ))}
              </div>

              {/* Support Info */}
              <div className="mt-10 pt-7 border-t border-background-50/15 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-user-smile-line text-background-50 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-[13px] font-label font-semibold text-background-50">
                      Support Team
                    </p>
                    <p className="text-[11px] text-background-50/50 font-body">
                      Available 24/7
                    </p>
                  </div>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-50/20 text-[12px] font-label font-semibold text-background-50 hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Ask More
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Schema.org FAQPage Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.q,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.a,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}